import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';
import s from '../styles/DetailContent.module.css';

const Knowledge38 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='東急ゴルフリゾートとは？' fontWeight={700} />
                <p>
                    東急ゴルフリゾートとは、東急不動産ホールディングスグループが運営するゴルフ場のことです。
                    <br />
                    宮城県から千葉県まで、関東・東北エリアを中心にゴルフ場を展開しており、会員優待の対象施設として以下が案内されています。
                </p>
                <div className={s.h4_link}>・泉パークタウンゴルフ倶楽部（宮城県）</div>
                <div className={s.h4_link}>・筑波東急ゴルフクラブ（茨城県）</div>
                <div className={s.h4_link}>・猿島カントリー倶楽部（茨城県）</div>
                <div className={s.h4_link}>・サミットゴルフクラブ（茨城県）</div>
                <div className={s.h4_link}>・蓼科東急ゴルフコース（長野県）</div>
                <div className={s.h4_link}>・斑尾東急ゴルフクラブ（長野県）</div>
                <div className={s.h4_link}>・大多喜城ゴルフ倶楽部（千葉県）</div>
                <div className={s.h4_link}>・小見川東急ゴルフクラブ（千葉県）</div>
                <div className={s.h4_link}>・芝山ゴルフ倶楽部（千葉県）</div>
                <div className={s.h4_link}>・季美の森ゴルフ倶楽部（千葉県）</div>
                <div className={s.h4_link}>・鶴舞カントリー倶楽部（千葉県）</div>
                <div className={s.h4_link}>・勝浦東急ゴルフコース（千葉県）</div>
                <p>
                    ※上記は東急ゴルフリゾート公式サイトの会員優待制度ページに掲載されている施設です。コースにより会員募集の有無や名義書換の可否が異なりますので、詳しくは各コースにお問合せください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='東急ゴルフリゾートのゴルフ会員権の特典とは？' fontWeight={700} />
                <p>東急ゴルフリゾートで用意されている会員優待制度をご紹介します。</p>
                <Heading3 title='ゴルフ場特別ご優待' />
                <p>
                    東急ゴルフリゾート系列のゴルフ場では、季節ごとに優待料金表が発行されており、会員は系列コースを優待料金でプレーすることができます。
                </p>
                <Heading3 title='リゾートホテルご利用ご優待' />
                <p>
                    東急ゴルフリゾートの会員には、系列リゾートホテル「ホテルハーヴェスト」の優待利用チケットが年2回（6月・12月）送付され、優待価格でホテルを利用することができます。
                    <br />
                    ※特典の詳細や対象コースは変更される場合がありますので、最新情報は公式サイトでご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='東急ゴルフリゾートのおすすめのゴルフ場は？' fontWeight={700} />
                <p>
                    東急ゴルフリゾートの全国のゴルフ場一覧は
                    <a href='https://juchi.jp/courses?series_id=17' className={s.link}>
                        こちら
                    </a>
                    よりご確認ください。
                    <br />
                    その中でも代表的なゴルフ場の一つをご紹介します。
                </p>
                <Heading3 title='東急ゴルフリゾートのコースをご紹介' />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/58'>勝浦東急ゴルフコース</a>
                </div>
                勝浦東急ゴルフコースは、千葉県勝浦市にある東急ゴルフリゾート系列のゴルフ場です。
                <br />
                太平洋を望む高台に広がる丘陵コースで、アウトは打ち下ろしのホールが続き、春には山桜や勝浦湾の景色を楽しめます。インには5ホールで池が絡み、戦略性の高いレイアウトです。
                <br />
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    上述のように、東急ゴルフリゾートではリゾートホテルの優待利用など他にはない特典があります。
                    <br />
                    <br />
                    また、関東・東北エリアに複数のゴルフ場があるため、系列コースを組み合わせて楽しみたい方からも人気を集めています。
                    <br />
                    <br />
                    具体的なコースの特徴や売買状況については、お気軽に弊社にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge38;
